import React from "react"

const List = ({type, children, className, ...otherProps}) => {

  if (type === "ol") {
    return (
      <ol className="" {...otherProps}>
        {children}
      </ol>
    )
  }

  return (
    <ul className={className}>
      {children}
    </ul>
  ) 
}

export function ListItem({children, ...otherProps}) {
  return (
    <li className="my-2" {...otherProps}>{children}</li>
  )
}

export default List